import { useState } from "react";
import { authService } from "../../../services/index.js";

export const useForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

const sendResetLink = async (email) => {
  try {
    setIsLoading(true);
    setError("");
    setMessage("");

    const response = await authService.forgotPassword({ email });
    setMessage(response.message);
  } catch (err) {
    console.log("Forgot password error:", err); // ✅ add this
    setError(err?.response?.data?.message || "Something went wrong. Please try again.");
  } finally {
    setIsLoading(false);
  }
};

  return { sendResetLink, isLoading, message, error };
};